import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { ChatMessage } from '@connect-x-app/shared-view-models';

type Props = {
  user: ChatMessage['userInfo'];
};

export const UserInfo: FC<Props> = ({ user }) => {
  const { t } = useTranslation();

  if (!user?.id) {
    return (
      <div className="message-bubble-avatar-name">
        <Text color={COLORS.zulu.$08} size="SM" uppercase weight="bold">
          {t('USER.UNKNOWN')}
        </Text>
      </div>
    );
  }

  return (
    <div className="message-bubble-avatar-name">
      <Text color={COLORS.zulu.$08} size="SM" uppercase weight="bold">
        {user.title}
      </Text>
      {user.name ? (
        <Text color={COLORS.zulu.$04} size="XS" weight="semiBold">
          &nbsp;-&nbsp;{user.name}
        </Text>
      ) : null}
    </div>
  );
};
